// extracted by mini-css-extract-plugin
module.exports = {"graph":"SectorCard_graph__Xp5aw","grid":"SectorCard_grid__IRbrT","data":"SectorCard_data__dWmDS"};